export const TIPOS_INCIDENCIA = [
  "Limpieza viaria",
  "Recogida de residuos",
  "Contenedores",
  "Zonas verdes",
  "Mobiliario urbano",
  "Pintadas / Grafitis",
  "Otro",
];
